import routePaths from 'const/routePaths'
import { useAppSelector } from 'redux/hooks'
import { useHistory, useLocation } from 'react-router-dom'
import { selectShowCoBrowse } from 'redux/config/configSlice'
import { useEffect, useState } from 'react'
import useLogout from './useLogout'

/*
 ** requestCoBrowse -
 ** Login Page -> skip/ignore CoBrowseModal and startActiveSession
 ** Pre & Post Login Pages -> disclose they will be logged out by CoBrowseModal
 ** first modal button, click yes -> close modal, redirect to login, startActiveSession
 ** second modal button, click no -> close modal
 */

const startCoBrowseSession = () => {
  // startup Surfly session

  window.Surfly?.session?.()?.startLeader?.()
}

const COBROWSE_PARAM = 'cobrowse'

export const useCoBrowse = () => {
  const showCoBrowse = useAppSelector(selectShowCoBrowse)

  const history = useHistory()
  const location = useLocation()
  const logout = useLogout()

  const isLoginPage = location.pathname === routePaths.home
  const [showCobrowseModal, setShowCobrowseModal] = useState(false)

  const handleCoBrowseClick = () => {
    if (isLoginPage) {
      startCoBrowseSession()
      return
    }
    setShowCobrowseModal(true)
  }

  const handleCobrowseModalStart = () => {
    setShowCobrowseModal(false)
    const searchParams = new URLSearchParams(location.search)
    searchParams.append(COBROWSE_PARAM, 'true')
    history.push({ pathname: routePaths.home, search: searchParams.toString() })
    logout()
  }

  const handleCobrowseModalClose = () => {
    setShowCobrowseModal(false)
  }

  const isCoBrowseActive =
    showCoBrowse &&
    routePaths.registerChildAccount !== location.pathname &&
    !location.pathname.includes(routePaths.activation)

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search)
    const isStartCobrowse = searchParams.get(COBROWSE_PARAM) === 'true'

    if (isLoginPage && isStartCobrowse && !window.Surfly?.isInsideSession) {
      searchParams.delete(COBROWSE_PARAM)
      history.replace({ search: searchParams.toString() })
      startCoBrowseSession()
    }
  }, [location.search, isLoginPage, history])

  return {
    isCoBrowseActive,
    showCobrowseModal,
    handleCoBrowseClick,
    handleCobrowseModalStart,
    handleCobrowseModalClose
  }
}
